<template>
  <div>
    <div class="card">
      <div class="card-action white white-text"></div>
      <div class="card-content animated flipInX">
        <h5>Your Electricity Meter & Cable TV Decoder Now Have Their Own Unique Bank Account Numbers.</h5>
        <p>Simply make a bank transfer to the account to buy tokens or renew your cable subscription instantly.</p>
        <br>
             <p>
                <img src="ui/icons/5.png" alt="Time Loader"  style="height:15px; Width:15px"/> NO CONVENIENCE FEE               
              </p>
        <form
          @submit.prevent="updateAccount"
          id="form"
          style="margin-top: 30px"
        >
          <div class="row">
            <div class="input-field col s12 m8 offset-m2">
              <select
                v-model="fields.service"
                class="browser-default"
                id="biller"
              >
                <option value="" disabled selected>Select a biller</option>
                <option
                  v-for="biller in billers"
                  :key="biller.key"
                  :disabled="stage > 0"
                  :value="biller.key"
                >
                  {{ biller.value }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12 m8 offset-m2">
              <input type="text" v-model="fields.reference" :disabled="stage > 0"/>
              <label for="meternumber">Meter/SmartCard Number</label>
            </div>
          </div>
          <button
            class="waves-effect waves-light btn-small"
            @click.prevent="getAccount()"
            type="button"
            v-if="stage == 0 && !loading && !billLoader"
          >
            Submit
          </button>
          <div v-if="billLoader">
            <img src="ui/img/loading.svg" alt="Time Loader" /> <br />
            <i>Fetching Billers...</i>
          </div>
          <div class="row" v-if="stage > 0">
            <div class="col s12 m8 offset-m2">
              <div class="alert alert-info fade show" role="alert">
                <div v-if="accountExist">
                  <strong>Bank:</strong> {{ account.bank }} <br />
                  <strong>Account name:</strong> {{ account && account.account_name }} <br />
                  <strong>Account number:</strong> {{ account && account.account_number }} <br />
                  <strong>Customer reference:</strong> {{ account && account.customer_ref }} <br />
                  <strong>Customer phone:</strong> {{ account && account.customer_phone }} <br />
                </div>
                <div v-else>
                  <strong>Customer name:</strong> {{ account.customer_name }} <br />
                  <strong>Customer Address:</strong> {{ account && account.customer_address }} <br />
                  <strong>Reference:</strong> {{ account && account.reference }} <br />
                </div>
                <strong>Service:</strong> {{ account.service }} <br />
              </div>
            </div>
          </div>
          <div class="row" v-if="stage > 0">
            <div class="input-field col s12 m8 offset-m2" v-if="!accountExist">
                <input type="text" v-model="fields.customer_name" id="name" />
                <label for="phone">Name</label>
              </div>
            <div class="input-field col s12 m8 offset-m2" style="padding: 0px">
              <div class="input-field col s6 m6">
                <input type="text" v-model="fields.phone" id="phone" />
                <label for="phone">Phone Number</label>
              </div>
              <div class="input-field col s6 m6">
                <input type="text" v-model="fields.email" id="email" />
                <label for="phone">Email</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="loading">
              <img src="ui/img/loading.svg" alt="Time Loader" />
            </div>
            <div class="col s12 m12" v-if="stage == 1 && !loading">
              <button
                class="waves-effect waves-light btn-small"
                type="button"
                @click.prevent="accountExist ? updateAccount() : generateAccount()"
              >
                {{ accountExist ? 'Update Account' : 'Generate Account' }}
              </button>
              <button
                class="waves-effect waves-light btn-small"
                type="button"
                style="margin-left: 15px"
                @click.prevent="paymentHistory()"
                v-if="accountExist"
              >
                Payment History
              </button>
            </div>
          </div>
          <div class="row">
            <br>
            <p style="font-size:20px">Why use this service?</p>
            <br>
            <div class="col s12 m3">
              <div class="row">
                <div class="col s3">
                <img src="ui/icons/4.png" alt="Time Loader"  style="height:50px; Width:50px"/>
                </div>
                <div class="col s9" style="text-align:left">
                  No need to expose your card details
                </div>
              </div>
            </div>
             <div class="col s12 m3">
             <div class="row">
                <div class="col s3">
                <img src="ui/icons/1.png" alt="Time Loader"  style="height:50px; Width:50px"/>
                </div>
                <div class="col s9" style="text-align:left;">
                Your Account Number is permanent and unique to your utility
                </div>
              </div>            
              </div>
             <div class="col s12 m3">
                  <div class="row">
                <div class="col s3">
                <img src="ui/icons/2.png" alt="Time Loader"  style="height:50px; Width:50px"/>
                </div>
                <div class="col s9" style="text-align:left">
                Payment can be scheduled for recurrent subscription
                </div>
              </div>  
            </div>
             <div class="col s12 m3" >
                  <div class="row">
                <div class="col s3">
                <img src="ui/icons/3.png" alt="Time Loader"  style="height:50px; Width:50px"/>
                </div>
                <div class="col s9" style="text-align:left">
                Saves you time and skip the usual long process of entering your details
                </div>
              </div>  
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="paymentHistory" class="modal services">
      <div class="modal-header">
        <a class="modal-close waves-effect btn-small waves-green right">x</a>
        <img src="ui/img/logo.png" width="18%" class="responsive-img" />
      </div>
      <div class="modal-content">  
      <table class="responsive-table">
        <thead>
          <tr>
              <th>#</th>
              <th>Amount</th>
              <th>Utility reference</th>
              <th>Date &amp; Time</th>
          </tr>
        </thead>
        <tbody v-if="transactions.length == 0">
          <tr>
            <td colspan="4" style="text-align: center">
              No record available
            </td>
          </tr>
        </tbody>
        <tbody v-if="transactions.length">
          <tr v-for="(item, index) in transactions" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.utility_ref }}</td>
            <td>{{ item.timestamp }}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    <div id="accountDetails" class="modal services">
      <div class="modal-header">
        <a class="modal-close waves-effect btn-small waves-green right">x</a>
        <img src="ui/img/logo.png" width="18%" class="responsive-img" />
      </div>
      <div class="modal-content">  
      <table class="responsive-table">
        <thead>
          <tr>
              <th>Title</th>
              <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Account name</td>
            <td>{{ newAccount.account_name }}</td>
          </tr>
          <tr>
            <td>Bank</td>
            <td>{{ newAccount.bank }}</td>
          </tr>
          <tr>
            <td>Account number</td>
            <td>{{ newAccount.account_number }}</td>
          </tr>
          <tr>
            <td>Customer reference</td>
            <td>{{ newAccount.customer_ref }}</td>
          </tr>
          <tr>
            <td>Customer name</td>
            <td>{{ newAccount.customer_name }}</td>
          </tr>
          <tr>
            <td>Customer phone</td>
            <td>{{ newAccount.customer_phone }}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    <div id="accountUpdateMessage" class="modal services">
      <div class="modal-header">
        <a class="modal-close waves-effect btn-small waves-green right">x</a>
        <img src="ui/img/logo.png" width="18%" class="responsive-img" />
      </div>
      <div class="modal-content">
   
        <p style="font-size:20px;">
          {{ updateMessage }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Adept',
  mounted() {
    // initialize modal for the document
    this.initModal()
    $('.bills__side__wrapper').removeClass('left_out')
    this.getBillers()
  },
  data() {
    return {
      update: false,
      fields: {
        action: 'irecharge_validate_web',
        service: '',
      },
      accountExist: false,
      loading: false,
      account: {},
      stage: 0,
      billers: [],
      modalInstance: {},
      newAccount: {},
      transactions: [],
      updateMessage: '',
      billLoader: false
    }
  },
  methods: {
    formatNumber(num) {
      var result = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      return result
    },
    getBillers() {
      this.billLoader = true
      var data = {
        action: 'get_billers',
        passcode: this.hash('Adept'),
      }
      this.axios
        .post('https://irecharge.com.ng/api/adept/get_billers.php', data)
        .then((response) => {
          if (response.data.status == 0) {
            this.billers = response.data.billers
          } else {
            $('.toast').hide()
            M.toast({ html: 'Unable to fetch billers', classes: 'info' })
          }
          this.billLoader = false
        })
        .catch((error) => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error',
          })
          this.billLoader = false
        })
    },
    updateAccount() {
      this.loading = true
      let data = {
        "action": "update",
        "reference": this.fields.reference,
        "service": this.fields.service,
        "new_phone": this.fields.phone,
        "passcode": this.hash('Adept')
      }
      this.axios
        .post(
          'https://irecharge.com.ng/api/adept/irecharge_update_web.php',
          data
        )
        .then((response) => {
          if (response.data.status == 0) {
            $('.toast').hide()
            this.updateMessage = response.data.message
            this.modalInstance[2].open()
            // to reset the page to the initial look and feel
            // just uncomment the following lines of code below
            // this.stage = 0
            // this.fields = {}
            // this.account = {}
          } else {
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
          this.loading = false
        })
        .catch((error) => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error',
          })
          this.loading = false
        })
    },
    generateAccount() {
      this.loading = true
      let data = {
        "action": "generate",
        "customer_name": this.fields.customer_name,
        "service": this.fields.service,
        "customer_phone": this.fields.phone,
        "customer_email": this.fields.email,
        "customer_ref": this.fields.reference,
        "passcode": this.hash('Adept')
      }
      this.fields.passcode = this.hash('Adept')
      this.axios
        .post(
          'https://irecharge.com.ng/api/adept/irecharge_generate_web.php',
          data
        )
        .then((response) => {
          if (response.data.status == 0) {
            this.newAccount = response.data
            this.modalInstance[1].open()
            // to reset the page to the initial look and feel
            // just uncomment the following lines of code below
            // this.stage = 0
            // this.fields = {}
            // this.account = {}
            // this.newAccount = {}
            $('.toast').hide()
          } else {
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
          this.loading = false
        })
        .catch((error) => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error',
          })
          this.loading = false
        })
    },
    ValidateData() {
      if (this.fields.phone) {
        if (this.fields.phone.toString().length === 11) {
          return true
        } else {
          $('.toast').hide()
          M.toast({
            html: 'Phone number must be 11 characters',
            classes: 'info',
          })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Phone number is required!', classes: 'info' })
      }
    },
    getAccount() {
      if (this.fields.service && this.fields.reference) {
        // send the request to check if the reference exist or not
        this.loading = true
        this.fields.passcode = this.hash('Adept')
        this.axios
          .post(
            'https://irecharge.com.ng/api/adept/irecharge_validate_web.php',
            this.fields
          )
          .then((response) => {
            if (response.data.status == 0) {
              this.account = response.data.data
              this.fields.phone = this.account.customer_phone
              this.stage = 1
              this.accountExist = response.data.is_registered
              $('.toast').hide()
            } else {
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
            this.loading = false
          })
          .catch((error) => {
            $('.toast').hide()
            M.toast({
              html:'Could not send request, check network.',
              classes: 'error',
            })
            this.loading = false
          })
      } else {
        this.loading = false
      }
    },
    proceedStage() {
      this.update = true
      this.stage = 2
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    },
    initModal() {
      // initialize modal for the document
      const option = {
        dismissible: false,
        endingTop: '6%',
        preventScrolling: true
      }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    paymentHistory() {
      this.loading = true
      let data = {
        "action": "history",
        "reference": this.fields.reference,
        "service": this.fields.service,
        "passcode": this.hash('Adept')
      }
      this.axios
        .post(
          'https://irecharge.com.ng/api/adept/irecharge_history_web.php',
          data
        )
        .then((response) => {
          if (response.data.status == 0) {
            this.transactions = response.data.items
            this.modalInstance[0].open()
          } else {
            this.modalInstance[0].open()
            // $('.toast').hide()
            // M.toast({ html: response.data.message, classes: 'info' })
          }
          this.loading = false
        })
        .catch((error) => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error',
          })
          this.loading = false
        })
    },
  },
}
</script>
<style scoped>
label {
  font-size: 1rem;
  color: #9e9e9e;
  font-weight: bold;
}
.card-content {
  padding: 0px 24px 24px;
}
.card .card-action {
  padding: 6px 24px;
}
.input-field {
  margin-top: 0px;
}
.alert-info {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
</style>
